<template>
  <div>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <table class="table table-hover table-responsive-md" v-if="loaded">
      <thead>
        <tr style="background-color:#eee;">
          <th>Name</th>
          <th>Card</th>
          <th>Email</th>
          <th>Phone</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td>{{ user.name_first + ' ' + user.name_last }}</td>
          <td>{{ user.roles[0] }}</td>
          <td><a :href="'mailto:' + user.email">{{ user.email }}</a></td>
          <td><a :href="'tel:' + user.phone_mobile">{{ user.phone_mobile }}</a></td>
          <th>
            <router-link :to="'/users/' + user.id + '/progression'" class="btn btn-success btn-sm">Student Progression</router-link>
          </th>
        </tr>
        <tr v-if="users.length === 0">
          <td colspan="5">No Users Assigned</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'MyUsers',
  data () {
    return {
      users: [],
      loaded: false
    };
  },
  methods: {
    loadUsers () {
      this.loaded = false;
      this.axios.get('/users').then(rsp => {
        this.users = rsp.data.data;
        this.loaded = true;
      }).catch((err) => this.$errorOut(err));
    }
  },
  mounted () {
    this.loadUsers();
  }
};
</script>

<style scoped>

</style>